import { PathOptions } from "leaflet";

export const ute_biomassa_base_existente = (feature: any): PathOptions => {
  return {
    color: "#8B4513",
    weight: 2,
    opacity: 1,
    fillColor: "#A0522D",
    fillOpacity: 0.6,
  };
};
